import React, { ChangeEvent } from 'react';

interface Option {
    value: string;
    label: string;
}

interface FormSelectProps {
    name: string;
    label: string;
    options: Option[];
    value: string | string[];
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    error?: string;
}

const FormSelect: React.FC<FormSelectProps> = ({ name, label, options, value, onChange, error }) => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        onChange(e);
    };

    return (
        <div className="mb-4">
            <label className="block mb-1 text-[16px] font-medium text-[#082743] dark:text-[#86A4C0]">{label}</label>
            <div className="space-y-2 grid sm:grid-cols-2 grid-cols-1">
                {options.map((option) => (
                    <div key={option.value} className="flex items-center ">
                        <input
                            type="checkbox"
                            name={name}
                            value={option.value}
                            checked={Array.isArray(value) ? value.includes(option.value) : value === option.value}
                            onChange={handleChange}
                            className="me-1 h-4 w-4 text-cardtitle focus:ring-primary-button"
                        />
                        <span className="text-[#666666] md:text-[16px] text-[14px]">{option.label}</span>
                    </div>
                ))}
            </div>
            {error && <p className="mt-1 text-sm text-red-600 text-right">{error}</p>}
        </div>
    );
};

export default FormSelect;
